/**
 * FC-1320: Override Yotpo review font-family to use Brandon Grotesque.
 * Yotpo dynamically injects broken @font-face for "Open Sans" that shadow
 * our CSS fix, so we use inline style !important on each element.
 */
(function () {
  const TARGET_SELECTOR = [
    '.yotpo-review-title',
    '.yotpo-reviewer-name',
    '.yotpo-review-content',
    '.yotpo-bottom-line-text',
    '.yotpo-bottom-line-basic-text',
    '.yotpo-sr-bottom-line-text',
    '.yotpo-sr-bottom-line-text--right-panel',
    '.yotpo-btn-s',
    '.yotpo-new-review-btn',
    '.yotpo-vertical-pagination a',
    '.yotpo-reviews-star-ratings-widget',
    '.yotpo-reviews-main-widget',
    '.yotpo-main-widget',
    '.yotpo-base-layout',
  ].join(',');

  const FONT_FAMILY = "'Brandon Grotesque', sans-serif";

  function fixElement(el) {
    if (!el || el.dataset.yotpoFontFixed) return;
    el.dataset.yotpoFontFixed = 'true';
    el.style.setProperty('font-family', FONT_FAMILY, 'important');
  }

  function fixAll() {
    document.querySelectorAll(TARGET_SELECTOR).forEach(fixElement);
  }

  // Fix existing elements
  fixAll();

  // Watch for dynamically added Yotpo elements
  const observer = new MutationObserver(function (mutations) {
    let shouldScan = false;
    for (const m of mutations) {
      if (m.addedNodes.length) {
        shouldScan = true;
        break;
      }
    }
    if (shouldScan) fixAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Also run on DOM ready and after a delay for late-loading widgets
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  }
  setTimeout(fixAll, 2000);
  setTimeout(fixAll, 5000);
})();
